// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2r76v","description":"styles_description__2werA","buttons":"styles_buttons__1l4aw"};